import React from 'react';
import { ArtworkCard } from './artworkCard';

export const ArtworkManagement = () => {
    return <ArtworkCard />
}
   